import dayjs from 'dayjs'
import dayjsBusinessTime from 'dayjs-business-time'
import 'dayjs/locale/de'
import dayjsUtc from 'dayjs/plugin/utc'
import type { DateString, TimestampString, TimestampTzString } from 'zapatos/db'

dayjs.locale('de')
dayjs.extend(dayjsUtc)
dayjs.extend(dayjsBusinessTime)

const masks = {
  default: 'DD.MM.YYYY',
  short: 'DD.MM.YYYY',
  medium: 'DD.MM.YYYY HH:mm',
  ticket: 'YYYY-MM-DD HH:mm:ss',
  long: 'dddd, DD. MMMM YYYY, HH:mm [Uhr]',
  file: 'YYYY-MM-DD-HH[h]mm',
  shortFile: 'YYYY-MM-DD',
  bill: 'DD.MM.YYYY, HH:mm [Uhr]',
  invoice: 'YYYY-MM-DD',
}

export type Dateish = Date | TimestampString | TimestampTzString | DateString

export function parseISO(date: dayjs.ConfigType) {
  return dayjs(date).toDate()
}

export function parseUTC(date: dayjs.ConfigType) {
  return dayjs.utc(date).toDate()
}

export function formatISO(date: dayjs.ConfigType) {
  return dayjs(date).format('YYYY-MM-DDTHH:mm:ss') as TimestampString
}

export function formatDate(date: Dateish, mask = 'DD.MM.YYYY') {
  if (!date) return ''

  return dayjs(date).format(masks[mask] || mask)
}

export function parseLooseDate(date: string) {
  if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return parseISO(date)
  } else {
    return dayjs(date, 'DD.MM.YYYY').toDate()
  }
}

export function addDays(
  date: Date,
  days: number,
  { onlyWorkdays } = { onlyWorkdays: false },
): Date {
  if (!onlyWorkdays) {
    return dayjs(date).add(days, 'days').startOf('day').toDate()
  } else {
    return dayjs(date).addBusinessDays(days).startOf('day').toDate()
  }
}

export function isFuture(date: dayjs.ConfigType) {
  return dayjs(date).isAfter(dayjs())
}

export function isPast(date: dayjs.ConfigType) {
  return dayjs(date).isBefore(dayjs())
}

export function isPastDay(date: dayjs.ConfigType) {
  return isPast(dayjs(date).endOf('day'))
}

export function isSameTime(a: dayjs.ConfigType, b: dayjs.ConfigType) {
  return dayjs(a).isSame(b, 'seconds')
}

// Returns true if the date of the performance is either today or in the future.
// So it returns true even if the performance is technically in the past, but happened today.
export function isUpcoming(performance: { startsAt: TimestampString }) {
  return dayjs(performance.startsAt).isAfter(dayjs().subtract(1, 'day'), 'day')
}
